export const networkType =
  (process.env.NEXT_PUBLIC_NETWORK_TYPE as "testnet" | "mainnet") || "mainnet";

const RPC_MAP = {
  mainnet: "https://base-mainnet.g.alchemy.com/v2/KOD2HT1qSjZjXKqGIm7Gj",
  testnet: "https://base-sepolia.g.alchemy.com/v2/KOD2HT1qSjZjXKqGIm7Gj",
};

const PUBLIC_RPC_MAP = {
  mainnet: "https://mainnet.base.org",
  testnet: "https://sepolia.base.org",
};

export const BASE_SEPOLIA_HTTP_RPC_URL = RPC_MAP[networkType];
export const BASE_PUBLIC_RPC_URL = PUBLIC_RPC_MAP[networkType];

export const VESTING_DURATION_DAYS = 180;
export const CLIFF_DURATION_DAYS = 60;

// export const VESTING_START_DATE = 1753088400000;
export const CLIFF_START_DATE = 1753779600 * 1000; // in contract, vestingStartTime
export const VESTING_START_DATE = 1758963600 * 1000; // in contract, cliffEndTime

export const REDMPTION_APP_URL = "https://earning.spheron.network";
export const STAKING_APP_URL = "https://staking-app-eight.vercel.app";
export const TOKENOMICS_URL =
  "https://sphn.notion.site/Spheron-Tokenomics-23db2d6b832a80038e19f464d708059a";

// Check for traffic overload environment variable
export const isTrafficOverload =
  process.env.NEXT_PUBLIC_TRAFFIC_OVERLOAD === "true";
